import React from "react";
import ReactDOM from "react-dom/client"; // ✅ use this package
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { Provider } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { createStore } from "redux";
import userDataStore from "./store/userDetails";
import { HelmetProvider } from "react-helmet-async";

// Initialize AOS
AOS.init();

// Create Redux store
const store = createStore(userDataStore);

// ✅ Create root and render
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <App />
  </HelmetProvider>
  </Provider>
);

// Optional: for performance monitoring
reportWebVitals();
